import { createFileRoute } from '@tanstack/react-router';
import { SystemStatusPage } from '../features/system/components/SystemStatusPage';

// The landing page.
export const Route = createFileRoute('/')({
  staticData: { public: true },
  component: SystemStatusPage,
});
